import React, { useEffect, useMemo, useState } from 'react'
import useSortableList from './useSortableList'
import { ListItem } from './ListItem'
import { SortHeader } from '../../../groups'
import { Box } from '@mui/material'
import { ListSkeleton } from './ListSkeleton'
import {
  useLazyGetAllModulesQuery,
  useLazyListOfCustomModulesQuery
} from '../../../../api/trainingPackages/trainingPackages'
import EmptyTable from '../../../../common/components/DataTable/EmptyTable'

export default function List({ search, input, language, type }) {
  const [getItems, { data, isLoading }] = useLazyGetAllModulesQuery()
  const [getCustomItems, { data: customModules, isLoading: isCustomLoading }] = useLazyListOfCustomModulesQuery()
  const [activeModulesCount, setActiveModulesCount] = useState({})

  const isDataLoading = isLoading || isCustomLoading

  const modulesList = useMemo(() => {
    if (type === 'CUSTOM') {
      return customModules || []
    }
    return data || []
  }, [data, customModules, type])

  const itemsWithActiveModules = useMemo(
    () =>
      modulesList?.map(item => ({
        ...item,
        activeModules: activeModulesCount[item.trainingId] || 0
      })),
    [modulesList, activeModulesCount]
  )

  const { sortedItems, handleSort, sortBy } = useSortableList(itemsWithActiveModules || [], activeModulesCount)

  useEffect(() => {
    if (type === 'CUSTOM') {
      getCustomItems({ language })
    } else {
      getItems({ language })
    }
  }, [language, type, getCustomItems, getItems])

  const filteredItems = useMemo(() => {
    return sortedItems?.filter(item => item.topic.toLowerCase().includes(search.toLowerCase()))
  }, [sortedItems, search])

  if (!filteredItems?.length) {
    return (
      <Box width='100%' display='flex' justifyContent='center' mt={4}>
        <EmptyTable title={'No results found'} />
      </Box>
    )
  }
  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <div className='row row-center groups-list-heading'>
        <SortHeader name='Name' sort={sortBy} onSort={handleSort} width={'80%'} />
        <SortHeader name='Active modules' sort={sortBy} onSort={handleSort} width={'15%'} />
      </div>

      {isDataLoading ? (
        <ListSkeleton count={5} />
      ) : (
        filteredItems?.map(item => (
          <ListItem
            setActiveModulesCount={setActiveModulesCount}
            input={input}
            key={item?.trainingId}
            item={item}
            search={search}
          />
        ))
      )}
    </Box>
  )
}
